<template>
  <div class="topBar">
    <div v-show="switchPrompt || !leadSteps.maskStep" class="purchaserMask hidden-xs hidden-sm" style="width: 100%;height: 100%;background: rgba(0, 0, 0, 0.75);position: fixed;z-index: 1052;top: 0px;"></div>
    <nav class="navbar navbar-default">
      <div class="container-fluid clearfix">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <a class="navbar-brand logo hidden-md hidden-lg" @click="goToHref('/')"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/mobile_logo.png" alt=""></a>
          <div class="search hidden-md hidden-lg">
            <a data-toggle="modal" data-target="#myModal2"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/search_icon.png" alt=""></a>
            <div class="modal fade" id="myModal2" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <div class="searchBox">
                    <el-input :placeholder="placeValue" v-model="selectContent" class="input-with-select" @keyup.enter.native="searchMobile()">
                      <el-button slot="append" icon="el-icon-search" @click="searchMobile()"></el-button>
                    </el-input>
                    <a @click="hideModal">取消</a>
                  </div>
                  <ul>
                    <li class="active"><a @click="roleSelect($event,1,'供应商、产品、服务')">供应商名称、产品、服务类别</a></li>
                    <!--<li><a @click="roleSelect($event,2,'产品、服务')">产品、服务类别</a></li>-->
                    <li><a @click="roleSelect($event,3,'集采协议')">集采协议</a></li>
                    <li><a @click="roleSelect($event,4,'招标公告')">招标公告</a></li>
                    <!--<li><a @click="roleSelect($event,5,'询价公告')">询价公告</a></li>-->
                    <!--<li><a @click="roleSelect($event,6,'中标公示')">中标公示</a></li>-->
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="dropdown" @mouseover.stop="open()">
            <a class="hidden-md hidden-lg" data-toggle="modal" data-target="#myModal" @mouseover.stop="open()"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/menu_icon.png" alt="" ></a>

            <div class="modal fade hidden-md hidden-lg" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel">
              <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                  <transition name="el-zoom-in-top">
                    <div class="searchBox" v-show="searchShow">
                      <el-input :placeholder="placeValue" v-model="selectContent" class="input-with-select" @keyup.enter.native="searchMobile()">
                        <el-button slot="append" icon="el-icon-search" @click.stop="searchMobile()"></el-button>
                      </el-input>
                      <a @click.stop="hideModal">取消</a>
                    </div>
                  </transition>
                  <transition name="el-zoom-in-top">
                    <ul class="searchBoxSelect" v-show="searchShow">
                      <li class="active"><a @click="roleSelect($event,1,'供应商、产品、服务')">供应商名称、产品、服务类别</a></li>
                      <li><a @click="roleSelect($event,3,'集采协议')">集采协议</a></li>
                      <li><a @click="roleSelect($event,4,'招标公告')">招标公告</a></li>
                    </ul>
                  </transition>
                  <transition name="el-zoom-in-top">
                    <div class="search" v-show="!searchShow">
                      <el-input @focus="searchJump" placeholder="请输入关键词查询" v-model="selectContent" class="input-with-select" >
                        <el-button slot="append" icon="el-icon-search" @click="searchShow=false"></el-button>
                      </el-input>
                    </div>
                  </transition>
                  <transition name="el-zoom-in-top">
                    <el-menu v-show="!searchShow" :default-active="activeIndex" class="el-menu-demo mobileDorp" mode="horizontal" @close="handleClose">
                      <el-menu-item index="1-11-11" @click="goHome()">首页</el-menu-item>
                      <el-submenu index="2-22-33" :popper-append-to-body="false">
                        <template slot="title" >商机查询</template>
                        <el-menu-item index="2-22-33-1" @click="showAll(2)" @focus="showAll(2)">招标公告<i class="el-icon-arrow-right"></i></el-menu-item>
                        <el-menu-item index="2-22-33-3" @click="showAll(1)" @focus="showAll(1)">询报价<i class="el-icon-arrow-right"></i></el-menu-item>
                        <el-menu-item index="2-22-33-2" @click="showAll(3)" @focus="showAll(3)">中标公告<i class="el-icon-arrow-right"></i></el-menu-item>
                      </el-submenu>
                      <el-menu-item index="3-33-44">
                        <a :href="yellowPageColumn.columnAccessPath" target="_blank">供应商资源大厅</a>
                      </el-menu-item>
                      <el-submenu index="4-55-66" :popper-append-to-body="false">
                        <template slot="title">产品与服务介绍</template>
                        <el-menu-item v-for="(child,childIndex) in productAndSolutionColumn.children" :key="childIndex" :index="child.columnId">
                          <a v-if="child.columnName !== '企业电商'" @click="clickMenu(child)">{{child.columnName}}</a>
                          <a v-if="child.columnName === '企业电商'" :href="child.columnAccessPath" target="_blank">{{child.columnName}}</a>
                        </el-menu-item>
                      </el-submenu>
                      <el-menu-item index="6-77-88" @click='jump("/protocol")'>复星战略协议</el-menu-item>
                      <el-menu-item index="7-88-99" @click='jumpFXG'>福星购
                        <i class="icon-new"></i>
                      </el-menu-item>
                      <div class="navRole bottomNav clearfix" v-if="isLogin == '100'">
                        <el-menu-item index="8-99-103" @click='jump("/messageNotification")'>消息通知<span class="badge">{{messageNumber}}</span></el-menu-item>
                        <el-menu-item index="8-99-104" class="pull-right" @click="loginOut()">退出</el-menu-item>
                      </div>
                      <div class="navRole bottomNav clearfix" v-if="isLogin == ''">
                        <el-menu-item index="8-99-105" @click='goToLogin'>登录</el-menu-item>
                      </div>
                    </el-menu>
                  </transition>
                </div>
              </div>
            </div>
            <el-menu :default-active="activeIndex" class="el-menu-demo hidden-xs hidden-sm" mode="horizontal"  @close="handleClose" background-color="#212933" text-color="#A8ACB2"  unique-opened :menu-trigger="trggierTyle">
              <el-submenu index="11-11-11" popper-class="topNav">
                <template slot="title">
                  <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/menu_icon.png" alt=""><span>网站导航</span>
                </template>
                <div class="search">
                  <el-input :placeholder="menuPlace" v-model="selectContent" class="input-with-select" @keyup.enter.native="search()">
                    <el-select v-model="selectType" slot="prepend" placeholder="供应商搜索"  popper-class="navSelect" :popper-append-to-body="false" @change="menuPlaceFn">
                      <el-option label="供应商名称、产品、服务类别" value="1"></el-option>
                      <el-option label="集采协议" value="3"></el-option>
                      <el-option label="招标公告" value="4"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
                  </el-input>
                </div>
                <el-menu-item index="2-22-33-1" @click='viewPurchaser("/")'>首页</el-menu-item>
                 <el-submenu index="1-2" popper-class="secondLevelNav">
                  <template slot="title" >商机查询</template>
                   <el-menu-item index="1-2-1" @click="showAll(2)">招标公告</el-menu-item>
                   <el-menu-item index="1-2-3" @click="showAll(1)">询报价</el-menu-item>
                   <el-menu-item index="1-2-2" @click="showAll(3)">中标公示</el-menu-item>
                </el-submenu>
                <el-menu-item index="1-3">
                  <a :href="yellowPageColumn.columnAccessPath" target="_blank">供应商资源大厅</a>
                </el-menu-item>
                <el-submenu index="1-4" popper-class="thirdLevelNav">
                    <template slot="title">产品与服务介绍</template>
                    <el-menu-item v-for="(child,childIndex) in productAndSolutionColumn.children" :key="childIndex" :index="child.columnId">
                      <a v-if="child.columnName !== '企业电商'" @click="clickMenu(child)">{{child.columnName}}</a>
                      <a v-if="child.columnName === '企业电商'" :href="child.columnAccessPath" target="_blank">{{child.columnName}}</a>
                    </el-menu-item>
                  </el-submenu>
                <!-- <el-menu-item index="1-5" @click='jump("/creditService")'>采购咨询服务</el-menu-item> -->
                <el-menu-item index="1-8" @click='viewPurchaser("/protocol")'>复星战略协议</el-menu-item>

                <div class="navRole">
                  <el-menu-item index="1-4" @click="viewPurchaser('/purchaser')">我是采购商</el-menu-item>
                  <el-menu-item index="1-5" @click="viewPurchaser('/supplier')">我是供应商</el-menu-item>
                </div>
              </el-submenu>
            </el-menu>
          </div>
          <!--<a class="navbar-brand" href="#"><img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/menu_icon.png" alt=""></a>-->

        </div>
        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="backIndex nav navbar-nav hidden-xs hidden-sm">
            <li>|</li>
            <li><a @click="goToHref('/')">首页</a></li>
          </ul>
          <ul class="nav navbar-nav navbar-right hidden-xs hidden-sm">
            <li class="iconBadge"  v-if="isLogin == '100'">
              <transition name="el-fade-in">
              <div class="purchaserLeadStep" v-show="leadSteps.fifthStep">
                <p>点击 【消息】查看消息和待办列表，也可通过点击消息标题直接进入消息或待办详情页</p>
                <el-button @click.stop="topLead('fifthStep','sixthStep')">下一步</el-button>
                <div class="leadArrowDown">
                  <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">
                </div>
              </div>
                </transition>
              <el-dropdown @visible-change="showInfoFn" placement="bottom-start" :class="leadSteps.fifthStep?'topLead':''">
                <a @click="goToHref('/messageNotification')" id="showInfo">消息<span class="badge">{{messageNumber}}</span></a>
                <el-dropdown-menu slot="dropdown" :class="leadSteps.maskStep?'iconBadgeDrop':'hideDrop'">
                  <div class="iconDrop">
                    <ul>
                      <li v-for="(message,index) in messageData" :key="index" @click="jumpUrl(message.id,message.url,message.content,message.createTime,message.title,message)">
                        <p>{{message.title}}</p>
                        <span>{{message.createTime|time}}</span>
                      </li>
                    </ul>
                    <a @click="goToHref('/messageNotification')">查看更多>></a>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li class="platformMap">
              <transition name="el-fade-in">
                <div class="purchaserLeadStep" v-show="switchPrompt">
                  <p>【新一链网】已经上线啦，还不赶快来看看<el-checkbox v-model="checkedPrompt">不再提醒</el-checkbox><br></p>
                  <el-button @click.stop="toNewSite">关闭</el-button>
                  <div class="leadArrowDown">
                    <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">
                  </div>
                </div>
              </transition>
              <a class="highlight cursor-pointer" href="https://ebs.onelinkplus.com">切换新一链网</a>
            </li>
            <li class="platformMap">
              <transition name="el-fade-in">
                <div class="purchaserLeadStep" v-show="leadSteps.thirdStep">
                  <p>在【我的工作台】中，可查看一链平台主要产品模块，点击标题可直接进入相应功能页面</p>
                  <el-button @click.stop="topLead('thirdStep','fourthStep')">下一步</el-button>
                  <div class="leadArrowDown">
                    <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">
                  </div>
                </div>
              </transition>
              <a class="highlight cursor-pointer" @click="gotoWorkbench">我的工作台</a>
            </li>
            <li><a class="highlight" @click="jumpHelpCenter()">帮助中心</a></li>
            <li class="userInfo">
              <el-dropdown placement="bottom">
                <a class="highlight">增值服务</a>
                <el-dropdown-menu slot="dropdown" class="valueAdded">
                  <ul>
                    <!--<li><a @click="valueAdded('/creditService')">征信服务</a></li>-->
                    <!--<li><a @click="valueAdded('/supplierService')">供应商服务</a></li>-->
                    <!--<li><a @click="valueAdded('/consultingService')">采购商风控服务</a></li>-->
                    <!--<li><a @click="valueAdded('/creditReport')">采购商风控服务</a></li>-->
                    <li><a @click="valueAdded('/creditReport')">“安心采”服务</a></li>
                    <li><a @click="valueAdded('/supplierService')">“诚意供”服务</a></li>
                  </ul>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
            <li class="loginLink" v-if="Object.keys(isLogin).length==0"><a class="highlight" @click="goToLogin">登录</a></li>
            <li v-if="Object.keys(isLogin).length==0">|</li>
            <li class="loginLink" v-if="Object.keys(isLogin).length==0"><a class="highlight" @click="goRegister">注册</a></li>
            <li class="loginLink" v-if="Object.keys(isLogin).length==0" style="padding-left: 10px;"><a class="highlight" @click="goLoginEn">Login</a></li>

            <li class="userInfo" v-if="isLogin == '100'">
              <transition name="el-fade-in">
              <div class="purchaserLeadStep" v-show="leadSteps.sixthStep">
                <p>个人中心中，可切换用户所在企业，查看企业管理员，或点击用户头像修改个人信息</p>
                <el-button @click.stop="topLeadTy('sixthStep','maskStep')">立即体验</el-button>
                <div class="leadArrowDown">
                  <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">
                </div>
              </div>
                </transition>
              <el-dropdown @visible-change="isShowBusiness" :class="leadSteps.sixthStep?'topLead':''">
                <a class="has-leaf highlight">
                  {{userInfo.trueName|substr}}<i class="el-icon-arrow-down el-icon--right" style="color: #ccc;"></i>
                </a>
                <el-dropdown-menu slot="dropdown" :class="leadSteps.maskStep?'userInfoDrop':'hideDrop'">
                  <div class="media">
                  <div class="media-left">
                  <a @click="goToHref('/personalCenter')">
                    <span class="media-object img-circle">
                      <img :src="logoFileUrl" alt="...">
                    </span>
                  <img class="userIcon" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/user_icon01.png" alt="..."  v-if="userTag==20">
                  <img class="userIcon" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/%E4%BE%9Bicon.png" alt="..." v-if="userTag==10">
                  </a>
                  </div>
                  <div class="media-body media-middle">
                  <h4 class="media-heading">
                    <span @click="goToHref('/personalCenter')">{{userInfo.trueName}}</span>
                    <span class="setUser" @click="goToHref('/personalCenter')"></span>
                    <a @click="loginOut()" class="pull-right logout">退出</a>
                  </h4>
                  <p class="clearfix">
                    <span>{{userInfo.companyName}}</span>
                    <a class="businessChange pull-right" @mouseenter="showBusinessFn">切换企业</a>
                    <transition name="el-zoom-in-top">
                      <div class="userInfoDrop businessDrop" v-show="showBusiness">
                        <el-radio-group v-model="userInfo.companyId" @change="handleCommand">
                          <el-radio v-for="(org,index) in orgs" :key="index" :label="org.orgId">
                            <el-dropdown-item><span>{{org.orgName}}</span></el-dropdown-item>
                          </el-radio>
                        </el-radio-group>
                      </div>
                    </transition>
                    <!--<ul class="userInfoDrop businessDrop" v-show="showBusiness">-->
                      <!--<li class="active" v-for="(org,index) in orgs" :key="index" @click="handleCommand(org.orgId)" ><span>{{org.orgName}}</span></li>-->
                    <!--</ul>-->
                  </p>
                  <p class="clearfix">
                    <a class="businessChange" @mouseenter="showManagerFn">企业管理员</a>
                    <transition name="el-zoom-in-top">
                      <div class="userInfoDrop managerDrop" v-show="showManager">
                        <ul v-show="memUserDtos.length>0">
                          <li class="clearfix" v-for="(menuUser,index) in memUserDtos" :key="index"><span class="pull-left">{{menuUser.trueName}}</span> <span class="emailSpan">{{menuUser.email}}</span></li>
                        </ul>
                        <span v-show="memUserDtos.length<=0">无企业管理员，请联系客服（0516-87796393）</span>
                      </div>
                    </transition>
                  </p>
                  </div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>
        </div>

      </div>
    </nav>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import Cookies from 'js-cookie'
import {customRegisterButtonClick, customLoginButtonClick, customSearchButtonClick} from '@/assets/js/sensors'


export default {
  props: ['yellowPageColumn','productAndSolutionColumn','hitSearchUrl','enterpriseResourceBaseUrl'],
  data () {
    return {
      placeValue:'请输入供应商、产品、服务关键词查询',
      menuPlace:'请输入供应商、产品、服务关键词查询',
      searchShow:false,
      viewInquiryUrl:'',
      viewBussinessUrl:'',
      customerPageUrl:'',
      openedStyle:true,
      trggierTyle:"hover",
      activeIndex:"",
      isLogin:'',
      userInfo:{},
      logoFileInfo:{},
      logoFileUrl:'',
      orgs:[],
      companyInfo:{},
      messageNumber:'',
      platformMapInfo:{},
      selectContent:'',
      selectType:'1',
      mobileSelectType:'1',
      userTag:'',
      customerNoticeInfo:{},
      steelNoticeInfo:{},
      realEstaterNoticeInfo:{},
      customerWinningNoticeInfo:{},
      steelWinningNoticeInfo:{},
      inquiryNoticeInfo:{},
      accountInfo:{},
      userName:'',
      password:'',
      userId:'',
      messageData:[],
      noticeData:[],
      showBusiness:false,
      showManager:false,
      noticeInfos:[],
      supplierManagerUrl:'',
      coordinationManagerUrl:'',
      coordinationSupplierUrl:'',
      recruitPurchaserUrl:'',
      recruitSupplierUrl:'',
      coordinationSupplierAuthFlag:'',
      coordinationSystemAuthFlag:'',
      supplierManagerAuthFlag:'',
      memUserDtos:[],
      checkIsWanbangGroup:'',
      checkIsWanbangGroup:false,
      // isOperateQuestionNaire:false,
      checkIsFosunGroup: false,
      switchPrompt:true,
      checkedPrompt:false
    }
  },
  computed: mapState([
      'KP',
      'leadSteps'
  ]),
  created () {
    this.isLogin = this.getToken('isLogin');
    if(this.isLogin !=''){
      this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
      this.accountInfo = JSON.parse(this.getDAesString(this.getToken('accountInfo'),this.KP.key,this.KP.iv));
      this.userInfo.companyName = Cookies.get('companyName');
      this.userInfo.companyId = Cookies.get('justId');
      this.userName = this.accountInfo.userName;
      this.password = this.accountInfo.password;
      this.userId = this.userInfo.id;
      this.messageNumber = this.getDAesString(this.getToken('messageNumber'),this.KP.key,this.KP.iv);
      if(null != Cookies.get('checkIsWanbangGroup')){
        this.checkIsWanbangGroup = Cookies.get('checkIsWanbangGroup');
      }
      // 是否是复星群组
      this.checkIsFosunGroup = Cookies.get('checkIsFosunGroup') === '0' || false
      this.orgs = this.userInfo.orgs;
      this.logoFileInfo = this.userInfo.faviconFileDto;
      this.logoFileUrl = this.logoFileInfo.fileUrl;
      this.userTag = this.userInfo.userTag;
      if(Object.keys(this.logoFileUrl).length==0){
        this.logoFileUrl = 'https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/userImage.png';
      }
      this.coordinationSupplierAuthFlag = this.getToken('coordinationSupplierAuthFlag');
      this.coordinationSystemAuthFlag = this.getToken('coordinationSystemAuthFlag');
      this.supplierManagerAuthFlag = this.getToken('supplierManagerAuthFlag');
      this.refSysId = this.getDAesString(this.getToken('refSysId'),this.KP.key,this.KP.iv);
    };
    this.showPrompt();

  },
  mounted(){
    Object.assign(this, mapMutations(['modifyLeadStep']));
    this.hideModal();
    this.searchChange();

    // 给其他地方用的
    this.$store.commit('setUserInfo', this.userInfo)
  },
  methods:{
    async gotoWorkbench () {
      await this.$store.dispatch('findWebDtoHandler');
      this.$store.dispatch('informationCompletion', () => {
        this.$router.push('workBench')
      });
    },
    // todo 删除start
    openPlatformMap(){
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findPaltformMapInfo', {
      }).then((res) => {
        this.data = res.data;
        this.platformMapInfo =  this.data;
      }).catch((err) => {
        console.log(err)
      })
    },
    jumpExt(url,type){
      this.$router.push({path:url,query:{bussiessType:type}})
    },
    // todo 删除end
    goToLogin () {
      // 埋点
      try {
        let documentTitle = "一链网"
        switch (this.$route.name) {
          case "index":
            documentTitle = "首页";
            break;
          case "supplier":
            documentTitle = "招标公告";
            break;
          case "protocol":
            documentTitle = "复星战略协议";
            break;
          case "recruitmentSystem":
            documentTitle = "招投标平台";
            break;
          case "supplyChain":
            documentTitle = "供应链协同";
            break;
          case "supplierManagement":
            documentTitle = "供应商管理";
            break;
        }
        if (documentTitle != "一链网") {
          customLoginButtonClick({
            page_title: documentTitle
          })
        }
      } catch (e){ console.log(e) }
      this.$router.push({path:'/login'})
    },
    // 跳转福星购
    jumpFXG () {
      let url = location.href;
      let evn = (/local.onelinkplus.com/.test(url) || /test/.test(url) ? "test-" : /uat/.test(url) ? "uat-" : "");
      location.href = `http://${evn}ecomall.onelinkplus.com/#/home`;
    },
    // 去英文版登录
    goLoginEn () {
      this.$router.push({path:'/loginEn'});
    },

    viewTenderBussiness(url,bulletinId){
      window.location.href=this.customerPageUrl + url + bulletinId;
//      this.pagePosition();
    },
    viewBussiness(url,projectId){
      this.$axios.post('/onelink.mdata.main.api/recruitInfo/getUrlSignature?url='+url+projectId+'&accessToken='+this.accessToken, {
      }).then((res) => {
        this.data = res.data;
        window.location.href = this.customerPageUrl + this.data;
      }).catch((err) => {
        console.log(err)
      })
//      this.pagePosition();
    },
    viewWinddingBussiness(bulletinName,conditions){
//      this.$router.push({path:'/supplier',query:{searchKeyWord:bulletinName,bussiessType:3}})
      if(this.$route.path=="/supplier"){
        this.$emit('conditionsSearchContent',{bussiessType:3,keyword:bulletinName,sourceType:conditions})
      }else{
        this.$router.push({path:'/supplier',query:{searchKeyWord:bulletinName,bussiessType:3,sourceType:conditions}})
      }
      this.pagePosition();
    },
    showInfoFn(){
      if(this.leadSteps.maskStep == false){
        return;
      };
      this.$axios.post('/onelink.mdata.main.api/message/findTodoInfo', {
        isFinish:0,
        pageNo:1,
        pageSize:4
      }).then((res) => {
        this.loading=false;
        this.data = res.data;
        this.messageData = this.data.queryTodoResponse.list;
        this.noticeData = this.data.queryNotifyResponse.list;
        if(Object.keys(this.noticeData).length >0 && this.messageData.length <4){
          this.messageData = this.messageData.concat(this.noticeData);
        }
        if(this.data.messageNumber>99){
          this.messageNumber = '99+';
        }else{
          this.messageNumber = this.data.messageNumber;
        }

        this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
      }).catch((err) => {
          console.log(err)
      })
    },
    hideModal(){
      $('#myModal2').modal('hide');
      $('#myModal').modal('hide');
      $(".modal-backdrop").remove();
      $('html,body').removeClass('modal-open');
      this.searchShow = false;
    },
    searchChange(){
      $('#myModal').on('hidden.bs.modal', () => {
        this.searchShow = false;
      })
    },
    viewPurchaser(url){
      $('#myModal2').modal('hide');
      $('#myModal').modal('hide');
      if(url.indexOf('supplier')){
        this.$router.push({path:url,query:{shortcutMenu:'10'}});
      }else{
        this.$router.push({path:url});
      }

    },
    showAll(bussinessType,sourceType){
      $('#myModal2').modal('hide');
      $('#myModal').modal('hide');
//      this.$router.push({path:'/supplier',query:{bussiessType:bussinessType,sourceType:sourceType}});
//      this.$emit('searchBussiness',{bussiessType:bussinessType,sourceType:sourceType})
       if(this.$route.path=="/supplier"){
         this.$emit('conditionsSearchContent',{bussiessType:bussinessType,keyword:'',sourceType:sourceType})
       }else{
        this.$router.push({path:'/supplier',query:{bussiessType:bussinessType,sourceType:sourceType}});
       }
      this.pagePosition();
      $('#myModal').modal('hide');
    },
    openPurchaser(){

    },
    open(){
      // if(key == '1-2-1'){
        this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectAllRecruitInfo', {
          pageSize:3,
          pageNo:1
        }).then((res) => {
          this.data = res.data;
          this.supplierManagerUrl = this.data.supplierManagerUrl;
          this.coordinationManagerUrl = this.data.coordinationManagerUrl;
          this.coordinationSupplierUrl = this.data.coordinationSupplierUrl;
          this.recruitPurchaserUrl = this.data.recruitPurchaserUrl;
          this.recruitSupplierUrl = this.data.recruitSupplierUrl;
          // this.customerNoticeInfo=this.data.customerNoticeInfo;
          // this.steelNoticeInfo=this.data.steelNoticeInfo;
          // this.realEstaterNoticeInfo=this.data.realEstaterNoticeInfo;
          // this.customerWinningNoticeInfo=this.data.customerWinningNoticeInfo;
          // this.steelWinningNoticeInfo=this.data.steelWinningNoticeInfo;
          // this.inquiryNoticeInfo=this.data.inquiryNoticeInfo;
          this.viewInquiryUrl = this.data.viewInquiryUrl;
          this.viewBussinessUrl = this.data.viewBussinessUrl;
          this.customerPageUrl = this.data.customerPageUrl;
        }).catch((err) => {
            console.log(err)
        })
      // }


    },
    jumpHelpCenter(){
      this.$router.push({path:'/helpCenter'})
    },
    goToHref(val){
      this.$router.push({path: val})
    },
    loginOut(){
      $('#myModal2').modal('hide');
      $('#myModal').modal('hide');
      this.$axios.post('/onelink.mdata.main.api/user/loginOut', {
      }).then((res) => {
        this.data = res.data;
        let logoutFlag = this.data.loginOutFlag;
        if(logoutFlag){
          this.removeToken('isLogin');
          this.removeToken('userInfo');
          this.removeToken('companyInfo');
          this.removeToken('checkFlag');
          this.removeToken('examineStatus');
          this.removeToken('exmaineMessage');
          this.removeToken('noticeInfos');
          this.removeToken('userTag');
          this.removeToken('coordinationSupplierAuthFlag');
          this.removeToken('coordinationSystemAuthFlag');
          this.removeToken('messageNumber');
          this.removeToken('supplierManagerAuthFlag');
          this.removeToken('isCompanyManager');
          this.removeToken('privacyPolicyFlag');

          Cookies.remove('isLogin');
          Cookies.remove('userInfo');
          Cookies.remove('companyInfo');
          Cookies.remove('checkFlag');
          Cookies.remove('examineStatus');
          Cookies.remove('exmaineMessage');
          // 埋点
          try {
            sensors.logout();
          } catch (err) {
            console.log(err)
          }
          this.$router.push({path:'/login'})
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    handleCommand(command) {
      this.$axios.post('/onelink.mdata.main.api/user/switvhCompany', {
        userId:this.userId,
        rememeberPassword:true,
        companyId:command
      }).then((res) => {
        this.data = res.data;
        // 登录后全部用户信息
        this.setToken('loginInfo', this.getAesString(JSON.stringify(this.data || {}), this.KP.key, this.KP.iv));
//         console.log(this.data.data.companyInfo.orgName);
        // this.userInfo.companyName = this.data.uCenterMemberInforDto.companyName;
        // this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
        // this.setToken('companyInfo',this.getAesString(JSON.stringify(this.data.uCenterMemberInforDto.uCenterORGUserRelationsDto),this.KP.key,this.KP.iv));
        this.loginFlag = this.data.loginFlag;
        this.userInfo =this.data.uCenterMemberInforDto;
        this.userTag = this.userInfo.userTag;
        this.companyInfo = this.data.uCenterMemberInforDto.uCenterORGUserRelationsDto;
        this.messageNumber = this.data.messageNumber;
        this.regeisterType =this.data.registerType;
        this.checkFlag = this.data.checkFlag;
        this.checkCardInfo = this.data.checkCardInfo;
        this.isCompanyManager = this.data.isCompanyManager;
        // this.coordinationSupplierAuthFlag = this.data.coordinationSupplierAuthFlag;
        // this.coordinationSystemAuthFlag = this.data.coordinationSystemAuthFlag;
        // this.supplierManagerAuthFlag = this.data.supplierManagerAuthFlag;
        this.noticeInfos = this.data.noticeInfos;
        Cookies.set('companyName',this.userInfo.companyName,{domain:'.onelinkplus.com',expires:10 });

        this.setToken('userTag',this.userTag);
        this.setToken('noticeInfos',JSON.stringify(this.noticeInfos))
        if(this.isCompanyManager){
          this.setToken('isCompanyManager',100);
          Cookies.set('isCompanyManager',100,{domain:'.onelinkplus.com'});
        }else{
          this.setToken('isCompanyManager','');
          Cookies.set('isCompanyManager','',{domain:'.onelinkplus.com'});
        }
        if(Number(this.messageNumber) > 99){
          this.messageNumber = '99+';
        }else{
          this.messageNumber = this.messageNumber;
        }
        this.accountInfo.userName = this.userName;
        this.accountInfo.password = this.password;
        this.checkIsWanbangGroup = this.data.checkIsWanbangGroup;
        if(this.checkIsWanbangGroup){
          this.setToken('checkIsWanbangGroup',this.getAesString("0",this.KP.key,this.KP.iv));
          Cookies.set('checkIsWanbangGroup',"0",{domain:'.onelinkplus.com',expires:10 });
        }else{
          this.setToken('checkIsWanbangGroup',this.getAesString("1",this.KP.key,this.KP.iv));
          Cookies.set('checkIsWanbangGroup',"1",{domain:'.onelinkplus.com',expires:10 });
        }

        this.checkIsFosunGroup = this.data.checkIsFosunGroup;
        if (this.checkIsFosunGroup) {
          this.setToken('checkIsFosunGroup',this.getAesString("0",this.KP.key,this.KP.iv));
          Cookies.set('checkIsFosunGroup',"0",{domain:'.onelinkplus.com',expires:10 });
        }else {
          this.setToken('checkIsFosunGroup', this.getAesString("1", this.KP.key, this.KP.iv));
          Cookies.set('checkIsFosunGroup', "1", {domain: '.onelinkplus.com', expires: 10});
        }

        if(this.loginFlag){
          if(this.data.coordinationSupplierAuthFlag){
            this.setToken('coordinationSupplierAuthFlag','100');
          }else{
            this.setToken('coordinationSupplierAuthFlag','200');
          }
          if(this.data.coordinationSystemAuthFlag){
            this.setToken('coordinationSystemAuthFlag','100')
          }else{
            this.setToken('coordinationSystemAuthFlag','200')
          }
          if(this.data.supplierManagerAuthFlag){
            this.setToken('supplierManagerAuthFlag','100')
          }else{
            this.setToken('supplierManagerAuthFlag','200')
          }

          //设置本地存储及vuex仓库中islogin的状态值
          this.setToken('isLogin',100);
          Cookies.set('isLogin',100,{domain:'.onelinkplus.com'});
          if(this.checkFlag){
            this.setToken('checkFlag',100);
            Cookies.set('checkFlag',100,{domain:'.onelinkplus.com'});
          }else{
            this.setToken('checkFlag',200);
            Cookies.set('checkFlag',200,{domain:'.onelinkplus.com'});
          }
          this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
          this.setToken('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv));
          this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
          this.setToken('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

          Cookies.set('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          Cookies.set('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          Cookies.set('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          Cookies.set('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});


          if(this.rememeberPassword){
            this.setToken('isRemember',100);
            this.setToken('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});

            Cookies.set('isRemember',100);
            Cookies.set('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          }else{
            this.setToken('isRemember','');

            Cookies.set('isRemember','',{domain:'.onelinkplus.com'});
          }
            this.setToken('examineStatus','');
            Cookies.set('examineStatus','',{domain:'.onelinkplus.com'});
            this.setToken('exmaineMessage','');
            Cookies.set('exmaineMessage','',{domain:'.onelinkplus.com'});
            this.$router.go(0);

        }else{
          this.setToken('isLogin',100);
          this.setToken('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv));
          this.setToken('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv));
          this.setToken('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv));
          this.setToken('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

          Cookies.set('isLogin',100,{domain:'.onelinkplus.com'});
          Cookies.set('userInfo',this.getAesString(JSON.stringify(this.userInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          Cookies.set('companyInfo',this.getAesString(JSON.stringify(this.companyInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          Cookies.set('messageNumber',this.getAesString(this.messageNumber,this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          Cookies.set('accountInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          if(this.rememeberPassword){
            this.setToken('isRemember',100);
            this.setToken('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv));

            Cookies.set('isRemember',100,{domain:'.onelinkplus.com'});
            Cookies.set('rememberInfo',this.getAesString(JSON.stringify(this.accountInfo),this.KP.key,this.KP.iv),{domain:'.onelinkplus.com'});
          }else{
            this.setToken('isRemember','');

            Cookies.set('isRemember','',{domain:'.onelinkplus.com'});
          }
          if(this.data.errorInfo == '该账户正在审核中'){
            this.setToken('examineStatus',200);

            Cookies.set('examineStatus',200,{domain:'.onelinkplus.com'});
            this.$router.push({path:"registerExamine",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName,createUserId:this.userInfo.createUserId}});
          }else if(this.data.errorInfo == '该账户审批未通过'){
            this.setToken('examineStatus',300);
            this.setToken('exmaineMessage',this.checkCardInfo.checkRemark);

            Cookies.set('examineStatus',300,{domain:'.onelinkplus.com'});
            Cookies.set('exmaineMessage',this.checkCardInfo.checkRemark,{domain:'.onelinkplus.com'});
            this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.regeisterType,exmaineMessage:this.checkCardInfo.checkRemark,createUserId:this.userInfo.createUserId}});
          }else{
              this.$message({
                message: '用户名和密码不符',
                type: 'error'
              });
          }

        }

      }).catch((err) => {
        console.log(err)
      })
    },
    handleOpen(key, keyPath) {
      // alert(key);
      // if(key == '1-2-1'){
      //   this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectAllInvitatioListPage', {
      //     pageSize:3,
      //     pageNo:1
      //   }).then((res) => {
      //     this.data = res.data;
      //     this.customerNoticeInfo=this.data.customerNoticeInfo;
      //     this.steelNoticeInfo=this.data.steelNoticeInfo;
      //     this.realEstaterNoticeInfo=this.data.realEstaterNoticeInfo;
      //   }).catch((err) => {
      //       console.log(err)
      //   })
      // }

      //  if(key == '1-2-2'){
      //   this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectAllCmsAwardInvitatioListPage', {
      //     pageSize:3,
      //     pageNo:1
      //   }).then((res) => {
      //     this.data = res.data;
      //     this.customerWinningNoticeInfo=this.data.customerWinningNoticeInfo;
      //     this.steelWinningNoticeInfo=this.data.steelWinningNoticeInfo;
      //   }).catch((err) => {
      //       console.log(err)
      //   })
      // }

      // if(key == '1-2-3'){
      //   this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectBulletinListPage', {
      //     pageSize:3,
      //     pageNo:1
      //   }).then((res) => {
      //     this.data = res.data;
      //     console.log(this.data);
      //     this.inquiryNoticeInfo=this.data;
      //   }).catch((err) => {
      //       console.log(err)
      //   })
      // }

    },
    handleClose() {
      //console.log('handleclose');
    },

    handleSelect (index, columnInfo) {

    },
    search(){
      if(this.selectType == '1'){
        window.location.href = this.hitSearchUrl + this.selectContent;
      }
      if(this.selectType == '2'){
        window.location.href = this.hitSearchUrl + this.selectContent;
      }
      if(this.selectType == '3'){
        if(this.$route.path=="/protocol"){
          this.$emit('selectKeyword',this.selectContent)
        }else{
          this.$router.push({path:'/protocol',query:{searchKeyWord:this.selectContent}})
        }

      }
      if(this.selectType == '4'){
        if(this.$route.path=="/supplier"){
          this.$emit('navSearchContent',{bussiessType:2,keyword:this.selectContent})
        }else{
          this.$router.push({path:'/supplier',query:{searchKeyWord:this.selectContent,bussiessType:2}})
        }

        this.pagePosition();
      }
      if(this.selectType == '5'){
        if(this.$route.path=="/supplier"){
          this.$emit('navSearchContent',{bussiessType:1,keyword:this.selectContent})
        }else{
          this.$router.push({path:'/supplier',query:{searchKeyWord:this.selectContent,bussiessType:1}})
        }
        this.pagePosition();
      }
      if(this.selectType == '6'){
        if(this.$route.path=="/supplier"){
          this.$emit('navSearchContent',{bussiessType:3,keyword:this.selectContent})
        }else{
          this.$router.push({path:'/supplier',query:{searchKeyWord:this.selectContent,bussiessType:3}})
        }

        this.pagePosition();
      }
      // 埋点
      try {
        customSearchButtonClick({position: "首页搜索"})
      } catch (e) {console.log(e)}
    },
    searchMobile(){
      $('#myModal2').modal('hide');
      $('#myModal').modal('hide');
      if(this.mobileSelectType == '1'){
        window.location.href = this.hitSearchUrl + this.selectContent;
      }
      if(this.mobileSelectType == '2'){
        window.location.href = this.hitSearchUrl + this.selectContent;
      }
      if(this.mobileSelectType == '3'){
        this.$router.push({path:'/protocol',query:{searchKeyWord:this.selectContent}})
      }
      if(this.mobileSelectType == '4'){
        this.$router.push({path:'/supplier',query:{searchKeyWord:this.selectContent,bussiessType:2}})
        this.pagePosition();
      }
      if(this.mobileSelectType == '5'){
        this.$router.push({path:'/supplier',query:{searchKeyWord:this.selectContent,bussiessType:1}})
        this.pagePosition();
      }
      if(this.mobileSelectType == '6'){
        this.$router.push({path:'/supplier',query:{searchKeyWord:this.selectContent,bussiessType:3}})
        this.pagePosition();
      }
    },
    jump(url){
      $('#myModal2').modal('hide');
      $('#myModal').modal('hide');
      if(this.getToken('isLogin') == '' && url !='/protocol'){
        this.$router.push({path:'/login'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }else{
        if(url.indexOf('http') == 0){
          if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
            this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
                dangerouslyUseHTMLString: true,
                customClass:'mobileText',
                center: true,
                showClose:false
              });
          }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
            this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
              cancelButtonClass:'cancelBtn',
              customClass:'mobileText',
              cancelButtonText: '以后再说',
              confirmButtonText: '点我补全',
              center: true
            }).then(() => {
              this.$router.push({path:'/inforPerfection'});
            }).catch(() => {
                this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
                }).then((res) => {
                  this.data = res.data;
                  this.removeCookie('TALK_LATER_'+this.data.userId);
                  this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
                });
            });
          }else{
            window.location.href = url;
          }
        }else{
          this.$router.push({path:url});
        }
      }
    },
    async jumpUrl(id,url,content,time,title,message){
      try {
        await this.$store.dispatch('findWebDtoHandler');
      } catch (e) {}
      if(this.getToken('isLogin') == '' && url !='/protocol'){
        this.$router.push({path:'/login'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      } else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      } else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
          cancelButtonText: '以后再说',
          confirmButtonText: '点我补全',
          center: true
        }).then(() => {
          this.$router.push({path:'/inforPerfection'});
        }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              this.data = res.data;
              this.removeCookie('TALK_LATER_'+this.data.userId);
              this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
            });
        });
      }
      else{
        if(typeof(url) == "undefined"){
          if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
            this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
                dangerouslyUseHTMLString: true,
                customClass:'mobileText',
                center: true,
                showClose:false
              });
          }
          else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
            this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
              cancelButtonClass:'cancelBtn',
              customClass:'mobileText',
              cancelButtonText: '以后再说',
              confirmButtonText: '点我补全',
              center: true
            }).then(() => {
              this.$router.push({path:'/inforPerfection'});
            }).catch(() => {
                this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
                }).then((res) => {
                  this.data = res.data;
                  this.removeCookie('TALK_LATER_'+this.data.userId);
                  this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
                });
            });
          }else{
            if(typeof(url) == "undefined"){
              this.$axios.post('/onelink.mdata.main.api/message/markRead', {
                id:id
              }).then((res) => {
                  this.$router.push({path:'/messageNotificationDetails',query:{noticeId:id}})
              }).catch((err) => {
                console.log(err)
              })
            }else{
              if(message.productLine == '供应商管理'){
                 window.location.href = url+message.isFinish+"&Id="+message.id;
              }else{
                if(url.indexOf("?")>0){
                  window.location.href = url+"&todoId="+message.id;
                }else{
                  window.location.href = url+"?todoId="+message.id;
                }
              }
              // window.location.href = url;
            }
          }
        }else{
           if(message.productLine == '供应商管理'){
                window.location.href = url+message.isFinish+"&Id="+message.id;
            }else{
              if(url.indexOf("ep.fosunproperty.com")>0){
                // let userSsoToken = Cookies.get("user_sso_token");
                // let landedUrl = url+"&token="+userSsoToken;
                // window.location.href= landedUrl;
                let foSunUrl = "https://ep.fosunproperty.com:8888/";
                let userSsoToken = Cookies.get("user_sso_token");
                url = url.split("?")[1];
                let guid = this.getUrlKey('guid',"?"+url)
                let landedUrl = foSunUrl  +"Interface/YiLianAction.aspx?action=centerPage&token="+userSsoToken+"&pguid="+ this.refSysId+"&language=zh_CN";
                window.location.href= landedUrl;
              }else if(url.indexOf("?")>0){
                window.location.href = url+"&todoId="+message.id;
              }else{
                window.location.href = url+"?todoId="+message.id;
              }
            }
        }
      }
    },
    jumpPlatform(url,authUrl,userTag,flag){
      let currentAuth = '';
      if(flag == 'coordinationManager'){
        currentAuth = this.getToken('coordinationSystemAuthFlag');
      }
      if(flag == 'coordinationSupplier'){
        currentAuth = this.getToken('coordinationSupplierAuthFlag');
      }
      if(flag == 'supplierManagement'){
        currentAuth = this.getToken('supplierManagerAuthFlag');
      }
      if(this.getToken('isLogin') == '' && url !='/protocol'){
        this.$router.push({path:'/login'});
      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }else{
        if(url.indexOf('http') == 0){
          if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
            this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
                dangerouslyUseHTMLString: true,
                customClass:'mobileText',
                center: true,
                showClose:false
              });
          }
          else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
            this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
              cancelButtonClass:'cancelBtn',
              customClass:'mobileText',
              cancelButtonText: '以后再说',
              confirmButtonText: '点我补全',
              center: true
            }).then(() => {
              this.$router.push({path:'/inforPerfection'});
            }).catch(() => {
                this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
                }).then((res) => {
                  this.data = res.data;
                  this.removeCookie('TALK_LATER_'+this.data.userId);
                  this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
                });
            });
          }else{
            if(currentAuth == '100'){
              window.location.href = url;
            }else{
              this.$router.push({path:authUrl});
            }
          }
        }else{
          if(currentAuth == '100'){
            this.$router.push({path:url});
          }else{
            this.$router.push({path:authUrl});
          }

        }
      }
    },
    clickMenu(column){
      $('#myModal2').modal('hide');
      $('#myModal').modal('hide');
      // let columnPath = column.columnAccessPath;
      // if(columnPath.indexOf('http') == 0){
      //   window.location.href = columnPath;
      // }else{
      //   this.$router.push({path:columnPath});
      // }
      let url = column.columnAccessPath;
      if(this.getToken('isLogin') == ''){
        if(column.columnName == '供应商资源大厅' || column.columnName == '企业电商'){
          let routeData = this.$router.resolve({ path: '/recruit', query: {  redirctUtl: url } });
          window.open(routeData.href, '企业电商');
        }else {
          if(url.indexOf('http') == 0){
            window.location.href = url;
          }else{
            this.$router.push({path:url});
          }
        }

      }else if(this.getToken('examineStatus') == '200'){
        this.$router.push({path:url});

        // this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
      }else if(this.getToken('examineStatus') == '300'){
        this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
      }
      else if(this.getCookie("COMPANY_COMPLETE_STATUS_"+this.getCookie("justId")) == "1"){
        this.$alert('<p>企业变更信息已提交，请耐心等待审核结果</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true,
            showClose:false
          });
      }else if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
        this.$confirm('请立即完善企业信息', '您的企业信息不完整，无法进入项目。', {
          cancelButtonClass:'cancelBtn',
          customClass:'mobileText',
          cancelButtonText: '以后再说',
          confirmButtonText: '点我补全',
          center: true
        }).then(() => {
          this.$router.push({path:'/inforPerfection'});
        }).catch(() => {
            this.$axios.post('/onelink.mdata.main.api/web/operateTalkLater', {
            }).then((res) => {
              this.data = res.data;
              this.removeCookie('TALK_LATER_'+this.data.userId);
              this.setCookie('TALK_LATER_'+this.data.userId,this.data.instanceDay);
            });
        });
      }
      else{
        if(column.columnName == '供应商资源大厅' || column.columnName == '企业电商'){
          let routeData = this.$router.resolve({ path: '/recruit', query: {  redirctUtl: url } });
          window.open(routeData.href, '企业电商');
        }else{
          if(url.indexOf('http') == 0){
            window.location.href = url;
          }else{
            if(url.indexOf('recruitmentSystem') != -1){
              if(this.getToken('userTag') == '10'){
                window.location.href = this.recruitSupplierUrl;
              }else if(this.getToken('userTag') == '20'){
                window.location.href = this.recruitPurchaserUrl;
              }else{
                this.$router.push({path:'/recruitmentSystem'});
              }
            }else if(url.indexOf('supplyChain') != -1){
              if(this.getToken('userTag') == '10'){
                if(this.coordinationSupplierAuthFlag == '100'){
                  window.location.href = this.coordinationSupplierUrl;
                }else{
                  this.$router.push({path:'/supplyChain'})
                }
              }else  if(this.getToken('userTag') == '20'){
                if(this.coordinationSystemAuthFlag == '100'){
                  window.location.href = this.coordinationManagerUrl;
                }else{
                  this.$router.push({path:'/supplyChain'})
                }
              }else{
                this.$router.push({path:'/supplyChain'})
              }

            }else if(url.indexOf('supplierManagement') != -1){
              this.supplierManagerAuthFlag = this.getToken('supplierManagerAuthFlag');
              if(this.supplierManagerAuthFlag == '100'){
                window.location.href = this.supplierManagerUrl;
              }else{
                this.$router.push({path:'/supplierManagement'})
              }
            }else{
              this.$router.push({path:url});
            }
          }

        }
      }
    },
    goHome(){
      $('#myModal2').modal('hide');
      $('#myModal').modal('hide');
      this.$router.push({path:"/"})
    },
    jumpExt(url,type){
      this.$router.push({path:url,query:{bussiessType:type}})
    },
    roleSelect(e,selectType,placeName){
      this.placeValue = '请输入'+placeName+'关键词查询'
      $(e.target).parent('li').addClass('active');
      $(e.target).parent('li').siblings('li').removeClass('active');
      this.mobileSelectType = selectType;
    },
    menuPlaceFn(placeName){
      if(placeName == 1){
        this.menuPlace = '请输入供应商、产品、服务关键词查询'
      }else if(placeName == 3){
        this.menuPlace = '请输入集采协议关键词查询'
      }else if(placeName == 4){
        this.menuPlace = '请输入招标公告关键词查询'
      }
//      else if(placeName == 5){
//        this.menuPlace = '请输入询报价公告关键词查询'
//      }else if(placeName == 6){
//        this.menuPlace = '请输入中标公示关键词查询'
//      }
    },
    searchJump(){
      this.searchShow = true;
//      $('#myModal').modal('hide');
//      $('#myModal2').modal('show');
    },
    //    页面定位
    pagePosition(){
//      console.log(1)
//      console.log($("#supplierEntry").offset())
        $("html, body").animate({
          scrollTop: $("#supplierEntry").offset().top-30 }, {duration: 500,easing: "swing"});
    },
    showBusinessFn(){
      this.showBusiness=true;
      this.showManager=false;
    },
    showManagerFn(){
      this.$axios.post('/onelink.mdata.main.api/recruitInfo/selectOrgManager?orgId='+this.userInfo.companyId, {
      }).then((res) => {
        this.memUserDtos = res.data;
        this.showManager=true;
        this.showBusiness=false;

       }).catch((err) => {
        console.log(err)
      })

    },
    isShowBusiness(){
      this.showBusiness=false;
      this.showManager=false;
    },
    topLead(val1,val2){
//      this.$emit('stepShow',val1,val2)
      this['modifyLeadStep']({
        [val1]: false,
        [val2]:true
      })
    },
//    判断是否第一次登陆
    topLeadTy(val1,val2){
//      this.$emit('stepShow',val1,val2)
      if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
        return;
      }
      this['modifyLeadStep']({
        [val1]: false,
        [val2]:true
      })
      this.$axios.post('/onelink.mdata.main.api/user/userExperience', {
      }).then((res) => {
        this.setToken('isExperience',0)
        Cookies.set('isExperience',0,{domain:'.onelinkplus.com',expires:10 });
      }).catch((err) => {
        console.log(err)
      })
    },
    valueAdded(val){
      this.$router.push({path:val});
    },
    goRegister () {
      // 埋点
      try {
        let documentTitle="一链网"
        switch (this.$route.name) {
          case "index":
            documentTitle = "首页";
            break;
          case "supplier":
            documentTitle = "招标公告";
            break;
          case "protocol":
            documentTitle = "复星战略协议";
            break;
          case "recruitmentSystem":
            documentTitle = "招投标平台";
            break;
          case "supplyChain":
            documentTitle = "供应链协同";
            break;
          case "supplierManagement":
            documentTitle = "供应商管理";
            break;
        }
        if (documentTitle != "一链网") {
          customRegisterButtonClick({
            page_title: documentTitle
          })
        }
      } catch (e) {console.log(e)}

      this.$router.push({path: '/register'})
    },

    // 关闭提示新一链入口的操作
    toNewSite() {
      this.switchPrompt = false;
      if(this.checkedPrompt){
        Cookies.set('noPrompt',this.checkedPrompt,{domain:'.onelinkplus.com',expires:10});
      }
    },
    // 判断是否显示新一链入口的提示
    showPrompt(){
      if((window.location.pathname !== '/' && window.location.pathname !== '/register') || Cookies.get("noPrompt") == 'true'){
      // if(Cookies.get("noPrompt") == 'true'){
        this.switchPrompt = false;
      }
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/topBar/index.vue